export function store(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
}

export function retrieve(key) {
    return JSON.parse(sessionStorage.getItem(key))
}

export function clearStorage() {
    sessionStorage.clear()
}
